import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Polyline } from "@react-google-maps/api";

import { positionsActions } from "../store";

import PositionsMap from "./PositionsMap";

const API_INTERVAL = 10000;
const polyLineOptions = {
  strokeColor: "#000000",
  strokeOpacity: 1,
  strokeWeight: 3,
  fillColor: "#000000",
  fillOpacity: 9,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  zIndex: 1,
};

const SinglePositionsMap = () => {
  const dispatch = useDispatch();
  const [polyLineData, setPolyLineData] = useState([]);

  const selectedId = useSelector((state) => state.devices.selectedId);
  let user = useSelector((state) => state.session.user);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `/api/devices/${selectedId}/deviceLastPosition`
      );
      const dataRespone = await response.json();

      const polyLine = {
        lat: dataRespone.latitude,
        lng: dataRespone.longitude,
      };

      setPolyLineData((current) => {
        return [...current, polyLine];
      });

      if (dataRespone.deviceId) {
        dispatch(positionsActions.update([dataRespone]));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // fetchData();
    const interval = setInterval(() => {
      document.visibilityState == "visible" && fetchData();
    }, API_INTERVAL); // Fetch data every 10 seconds
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);
  const positions = useSelector((state) =>
    Object.values(state.positions.items)
  );

  const selectedPosition = positions.filter((item) => {
    return item.deviceId === selectedId;
  });

  return (
    <>
      <Polyline
        onLoad={() => {}}
        path={polyLineData}
        options={{
          ...polyLineOptions,
        }}
      />
      <PositionsMap positions={selectedPosition} />;
    </>
  );
};

export default SinglePositionsMap;
